import { Vector as VectorLayer } from "ol/layer";
import { Vector as VectorSource } from "ol/source";
import { Circle as CircleStyle, Fill, Icon, Stroke, Style } from "ol/style";
import IconAnchorUnits from "ol/style/IconAnchorUnits";
import ferryIcon from "~/assets/img/ferry_marker.svg";
import { LayerDefaults, LayerTitle } from "../types/layers";
import { readMapSettings } from "./localMapSettings";

interface Return {
  source: VectorSource;
  layer: VectorLayer;
}

function createFerryLayer(drawing?: boolean): Return {
  const source = new VectorSource();
  const title = drawing ? LayerTitle.FerriesDraw : LayerTitle.Ferries;
  const icon = `${window.location.origin}${ferryIcon}`;
  const layer = new VectorLayer({
    source,
    zIndex:
      readMapSettings("layers", title)?.zIndex ?? LayerDefaults[title].zIndex,
    visible:
      readMapSettings("layers", title)?.visible ?? LayerDefaults[title].visible,
    style: () => {
      return drawing
        ? new Style({
            image: new CircleStyle({
              radius: 7,
              fill: new Fill({
                color: "#797D7F",
              }),
              stroke: new Stroke({
                color: "#000",
                width: 1,
              }),
            }),
          })
        : new Style({
            image: new Icon({
              opacity: 1,
              src: icon,
              scale: 1.5,
              offset: [0, 0],
              anchor: [0.5, 24],
              anchorXUnits: IconAnchorUnits.FRACTION,
              anchorYUnits: IconAnchorUnits.PIXELS,
            }),
          });
    },
  });
  layer.set("title", title);

  return { source, layer };
}

export default createFerryLayer;
